import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { talkGroups } from "../../../constant/talks.constant";
import TalkItem from "./talk-item.component";

const TalksGrid = () => {
  return (
    <Box className="talks-groups">
      {talkGroups.map((group) => (
        <Box className="talks-group" key={`${group.event}-${group.year}`}>
          <Box className="talks-group-header">
            <Typography className="talks-group-title" variant="mainBlack">
              {group.event}
            </Typography>
            <Typography className="talks-group-year" variant="mainBlack">
              {group.year}
            </Typography>
          </Box>
          <Grid container className="talks-grid-container">
            {group.talks.map((talk, index) => (
              <TalkItem
                key={`${group.year}-${index}`}
                embedLink={talk.embedLink}
                name={talk.name}
                subject={talk.subject}
              />
            ))}
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default TalksGrid;
